<div
  class="cx-anonymous-consent-dialog"
  id="cx-anonymous-consent-matomo-dialog"
  [cxFocus]="focusConfig"
  (esc)="close('Escape clicked')"
>
  <div class="cx-dialog-content matomo-cx-dialog-content">
    <div id="matomo-opt-out">
      <eb-spinner></eb-spinner> {{ 'anonymousConsents.component.spinner.text' | cxTranslate }}
    </div>
  </div>
</div>
